import { FC, memo } from "react"
import { useTranslation } from "react-i18next"
import styles from "./VitalBars.module.scss"
import { vitalBarStyle } from "./helpers"
import { IVitalBars } from "./types"

const VitalBarsComponent: FC<IVitalBars> = ({ vitals }) => {
  const { t } = useTranslation("catalog")

  return (
    <div className={styles.VitalBars}>
      {vitals.map((vital) => (
        <div
          key={vital.code}
          className={styles.VitalBars_bar}
          style={vitalBarStyle(vital.code)}
        >
          <div
            className={styles.VitalBars_fill}
            style={{ transform: `scaleX(${vital.fill})` }}
          />
          <span className={styles.VitalBars_text}>
            {t(`vital.${vital.code}`, { defaultValue: vital.code })}{" "}
            {vital.current}/{vital.max}
          </span>
        </div>
      ))}
    </div>
  )
}

export const VitalBars = memo(VitalBarsComponent)
